import { INote } from "../Note";
import { PhysicalRouting } from "../Part";
import { BaseEntity } from "../system";

export enum AccountStatus {
  Archived,
  Disabled,
  Enabled,
}

export enum AccountType {
  Auto,
  Manual,
  eBay,
  PartPro,
  Shopify,
  Reuse,
  Remanufacturing,
  Reintegration,
  Recycling
}

export interface IAccount extends BaseEntity {
  accountNumber: number;
  name: string;
  status: AccountStatus;
  accountType: AccountType;
  isRsCore: boolean;
  physicalRoutingDefault: PhysicalRouting;
  billingAddressId?: string;
  shippingAddressId?: string;
  primaryContactId?: string;
  vatNumber?: string;
  creditLimit: number;
  accountNotes: INote[];
  bankAccountName: string;
  bankAccountNumber: string;
  bankSortCode: string;
  oracleCustomerNumber?: string;
  oracleCustomerSite?: string;
  oracleContactName?: string;
  oracleContactEmail?: string;
  oracleCustomerPoRef?: string;
  oracleLineItem?: string;
  /** DEFRA waste tracking: a third-party waste carrier that can be picked on the Waste Tracking page. */
  isHaulier: boolean;
  /** Waste carrier registration, e.g. CBDU123456. Required when isHaulier. */
  carrierRegistrationNumber?: string | null;
  /** Their usual truck or trailer registration; pre-fills a row that has none yet. */
  haulierVehicleRegistration?: string | null;
  deleted?: string;
}

export interface AccountCreateEditRequest
  extends Omit<
    IAccount,
    "id" | "created" | "updated" | "deleted" | "accountNumber"
  > { }

export interface AccountCreateEditFormFields
  extends Omit<AccountCreateEditRequest, "creditLimit"> {
  creditLimit: string;
  regularsAccount: boolean;
}
